__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "camerafi-admin";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mui/material", "5.14.7", () => (Promise.all([__webpack_require__.e(5148), __webpack_require__.e(2556), __webpack_require__.e(519), __webpack_require__.e(8460), __webpack_require__.e(2604), __webpack_require__.e(6979)]).then(() => (() => (__webpack_require__(48460))))));
			register("@mui/system", "5.17.1", () => (Promise.all([__webpack_require__.e(2556), __webpack_require__.e(667), __webpack_require__.e(2604), __webpack_require__.e(1573)]).then(() => (() => (__webpack_require__(20667))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(4164), __webpack_require__.e(2604)]).then(() => (() => (__webpack_require__(54164))))));
			register("react-router-dom", "6.15.0", () => (Promise.all([__webpack_require__.e(6276), __webpack_require__.e(2604)]).then(() => (() => (__webpack_require__(46276))))));
			register("react", "18.2.0", () => (__webpack_require__.e(2791).then(() => (() => (__webpack_require__(72791))))));
			initExternal(23732);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};